import TrueFalseAnswerService from 'services/task/subServices/questionTask/trueFalse/answer/subServices/TrueFalseAnswerService';

export default {
	'services.task.trueFalse.answer.trueFalse': {
		class: TrueFalseAnswerService,
		deps: [{ $ref: 'services.task.trueFalse.answer.mode' }],
	},
};
